import { render, staticRenderFns } from "./simpleAuth.vue?vue&type=template&id=ac8a8688&scoped=true&"
import script from "./simpleAuth.vue?vue&type=script&lang=js&"
export * from "./simpleAuth.vue?vue&type=script&lang=js&"
import style0 from "./simpleAuth.vue?vue&type=style&index=0&id=ac8a8688&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8a8688",
  null
  
)

export default component.exports